/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import {
  Navbar,
  Container,
  Nav,
  Button,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import swicthimg from "../../../assets/img/swicth.svg";
import * as UserProfileActions from "../../Actions/UserProfileActions/actions";
import { useDispatch } from "react-redux";

// import routes from "routes.js";

const Header = (props) => {
  const [domainName, setDomainName] = React.useState(
    `worldstream.${process.env.REACT_APP_ENV}`
  );
  const dispatch = useDispatch();
  const mobileSidebarToggle = (e) => {
    e.preventDefault();
    props.handleSiderHide();
    // document.documentElement.classList.toggle("nav-open");
    // var node = document.createElement("div");
    // node.id = "bodyClick";
    // node.onclick = function () {
    //   this.parentElement.removeChild(this);
    //   document.documentElement.classList.toggle("nav-open");
    // };
    // document.body.appendChild(node);
  };

  React.useEffect(() => {
    const allDomains = window.location.hostname.split(".");

    if (allDomains.length >= 3) {
      setDomainName(
        allDomains.slice(allDomains.length - 2, allDomains.length).join(".")
      );
    }
    if (allDomains.length === 2) {
      setDomainName(allDomains.join("."));
    }
  }, []);

  const Click = React.useCallback(() => {
    dispatch(UserProfileActions.showHidePropertyModal(true));
  }, [dispatch]);

  // const getBrandText = () => {
  //   // for (let i = 0; i < routes.length; i++) {
  //   //   if (location.pathname.indexOf(routes[i].layout + routes[i].path) !== -1) {
  //   //     return routes[i].name;
  //   //   }
  //   // }
  //   return "Brand";
  // };

  return (
    <Navbar bg="light" expand="lg">
      <Container fluid>
        <div className="d-flex justify-content-center align-items-center ml-2 ml-lg-0">
          {props.isShowSidebar && (
            <Button
              variant="dark"
              className="btn-fill d-flex justify-content-center align-items-center rounded-circle btn-toggle p-2 btn-toggle-new"
              onClick={mobileSidebarToggle}
            >
              {/* <i className="nc-icon nc-align-left-2 mt-0"></i> */}
              {/* <img src="../../../assets/img/menu.svg"/> */}
              <img
                src={require("../../../assets/img/menu.svg").default}
                alt="..."
              />
            </Button>
          )}
          {props.admin && (
            <div className="ml-3">
              <OverlayTrigger
                delay={{ show: 250, hide: 400 }}
                placement={"bottom"}
                overlay={<Tooltip id={`tooltip-qw`}>Switch Property</Tooltip>}
              >
                <div
                  className="text-nowrap text-truncate cursor-pointer"
                  onClick={Click}
                >
                  <img src={swicthimg} width="26" />
                </div>
              </OverlayTrigger>
            </div>
          )}
          {props.isShowSidebar &&
            props.domainHeader &&
            props.domainHeader.propertyName &&
            props.domainHeader.domainName && (
              <span className="ml-2 fs-14px">
                {`${props.domainHeader.propertyName} `}
                {props.permission_id === 1 && !props.adminLogin ? (
                  <a
                    className={"top-header--title"}
                    href={`https://${props.domainHeader.domainName}.${domainName}`}
                    target="_blank"
                    rel="noreferrer"
                  >{`${props.domainHeader.domainName}.${domainName}`}</a>
                ) : null}
              </span>
            )}
          {/* <Navbar.Brand
            href="#home"
            onClick={(e) => e.preventDefault()}
            className="mr-2"
          >
            {getBrandText()}
          </Navbar.Brand> */}
        </div>
        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" className="mr-2">
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
          <span className="navbar-toggler-bar burger-lines"></span>
        </Navbar.Toggle> */}
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav mr-auto" navbar>
            {/* <Nav.Item>
              <Nav.Link
                data-toggle="dropdown"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
                className="m-0"
              >
                <i className="nc-icon nc-palette"></i>
                <span className="d-lg-none ml-1">Dashboard</span>
              </Nav.Link>
            </Nav.Item> */}
            {/* <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                data-toggle="dropdown"
                id="dropdown-67443507"
                variant="default"
                className="m-0"
              >
                <i className="nc-icon nc-planet"></i>
                <span className="notification">5</span>
                <span className="d-lg-none ml-1">Notification</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Notification 1
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Notification 2
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Notification 3
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Notification 4
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Another notification
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
            {/* <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <i className="nc-icon nc-zoom-split"></i>
                <span className="d-lg-block">Search</span>
              </Nav.Link>
            </Nav.Item> */}
          </Nav>
          <Nav className="ml-auto" navbar>
            {/* <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
              >
                <span className="no-icon">Account</span>
              </Nav.Link>
            </Nav.Item> */}
            {/* <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                aria-expanded={false}
                aria-haspopup={true}
                as={Nav.Link}
                data-toggle="dropdown"
                id="navbarDropdownMenuLink"
                variant="default"
                className="m-0"
              >
                <span className="no-icon">Dropdown</span>
              </Dropdown.Toggle>
              <Dropdown.Menu aria-labelledby="navbarDropdownMenuLink">
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Action
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Another action
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Something
                </Dropdown.Item>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Something else here
                </Dropdown.Item>
                <div className="divider"></div>
                <Dropdown.Item
                  href="#pablo"
                  onClick={(e) => e.preventDefault()}
                >
                  Separated link
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
            {/* <Nav.Item>
              <Nav.Link
                className="m-0"
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault()
                  handleLogout()
                }}
              >
                <span className="no-icon">Log out</span>
              </Nav.Link>
            </Nav.Item> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
